import { BaseApi } from "./BaseApi";

export class LoginApi extends BaseApi {
    async realizarLogin(input: LoginApi.LoginApiInput) : Promise<LoginApi.LoginApiOutput> {
        return (await this.api.post(`/Login/RealizarLogin`, input)).data
    }
}

export namespace LoginApi {
    export type LoginApiInput = {
        Usuario:string
        Senha:string
        DadosLicenciamentoCodificados?:string
    }

    export type LoginApiOutput = {
        Status: "SUCESSO" | "FALHA"
    }
}